import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { SearchEdictRequest } from '../models/search-edict-request.model';
import { SearchEdictResponse } from '../models/search-edict-response.model';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DetailEdictResponse } from '../models/detail-edict-response.model';

@Injectable({
  providedIn: 'root'
})
export class CertService {

  constructor(
    private httpClient: HttpClient,
    private baseService: BaseService) { }

  searchEdicts(request: SearchEdictRequest): Observable<SearchEdictResponse> {
    const url = `${this.baseService.hostDomain}/api/cert/search`;
    return this.httpClient
      .post<SearchEdictResponse>(url, request)
      .pipe(
        catchError(err => {
          this.baseService.handleError(err, 'Buscando edictos');
          return [];
        })
      );
  }

  getDetail(id: string): Observable<DetailEdictResponse> {
    const url = `${this.baseService.hostDomain}/api/cert/detail/${id}`;
    return this.httpClient
      .get<DetailEdictResponse>(url)
      .pipe(
        catchError(err => {
          this.baseService.handleError(err, 'Retornando el detalle de edictos');
          return [];
        })
      );
  }

  downloadCert(id: string, publishDate: Date): Observable<any> {
    return this.httpClient
    .get(`/api/cert/generate/${id}?publishDate=${publishDate}`, {
       responseType: 'blob',
    })
    .pipe(
      catchError(err => {
        if (!(err.error instanceof Blob)) {
          this.baseService.handleError(err, 'Descargando PDF de certificación de edicto');
        }
        return [err];
      })
    );
  }

  downloadCertError(err: any) {
    const reader = new FileReader();

    reader.onloadend = () => {
      const text = reader.result as string;
      this.baseService.customError(text);
    };
    reader.readAsText(err.error);
  }

  sendEmailCert(id: string, email: string, publishDate: Date): Observable<any> {
    return this.httpClient
    .get(`/api/cert/sendemail/${id}?email=${email}&publishDate=${publishDate}`)
    .pipe(
      catchError(err => {
        this.baseService.handleError(err, 'Enviando email de certificación de edicto');
        return [err];
      })
    );
  }

  sendEmailCertError(errMsg: string) {
    this.baseService.customError(errMsg);
  }
}
